import { render } from "./Sessoes.vue?vue&type=template&id=0a88ac7d"
import script from "./Sessoes.vue?vue&type=script&lang=js"
export * from "./Sessoes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__